import React, { FC, JSXElementConstructor } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

import { PathNames } from 'application/routes/constants';
import { DocBaySupportLink } from 'application/constants/externalLinks';

import { MenuItemProps } from './models';
import { MenuItemStyled } from './styles';

const MenuItem: FC<MenuItemProps> = ({ path, name, Image }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const locationEndIndex = location.pathname.slice(1).indexOf('/');
  const locationMainPath = location.pathname.slice(0, locationEndIndex);

  const isCurrentPage = path.includes(locationMainPath);
  const isSupportItem = path === PathNames.support;

  const handleChangePath = () => {
    if (!isCurrentPage) {
      navigate(path);
    }
  };

  return (
    <MenuItemStyled>
      {isSupportItem ? (
        <Link to={DocBaySupportLink} target="_blank">
          <button type="button" className={`${isCurrentPage ? 'active' : ''}`}>
            {Image ? (
              <div className="menu_item">
                <Image />
                <p>{name}</p>
              </div>
            ) : (
              name
            )}
          </button>
        </Link>
      ) : (
        <button
          onClick={handleChangePath}
          className={`${isCurrentPage ? 'active' : ''}`}
        >
          {Image ? (
            <div className={'menu_item'}>
              <div className={'image-wrapper'}>
                <Image />
              </div>
              <p>{name}</p>
            </div>
          ) : (
            name
          )}
        </button>
      )}
    </MenuItemStyled>
  );
};

export default MenuItem;
